import i18n from '@/i18n';
const langPrefix = (override) => {
    const lang = override ?? i18n.global.locale.value;
    return lang === 'en' ? undefined : lang;
};
export const localizedTo = (name, params = {}, locale) => ({
    name,
    params: { ...params, lang: langPrefix(locale) },
});
export const localizedPath = (path, locale) => {
    const prefix = langPrefix(locale);
    if (!prefix)
        return path;
    return `/${prefix}${path === '/' ? '' : path}`;
};
